module.exports = {
	"id": "SY",
	"name": "Syrian Arab Republic",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": 0.00924,
			"6": 0.00308,
			"7": null,
			"8": 0.00924,
			"9": null,
			"10": 0.01232,
			"11": 0.0616,
			"12": 0.00924,
			"13": 0.00924,
			"14": 0.00616,
			"15": 0.02464,
			"16": null,
			"17": 0.00308,
			"18": 0.00616,
			"19": 0.00924,
			"20": 0.01232,
			"21": 0.00308,
			"22": 0.02156,
			"23": 0.01232,
			"24": 0.00616,
			"25": 0.01848,
			"26": 0.01232,
			"27": 0.02156,
			"28": 0.01232,
			"29": 0.0154,
			"30": 0.02156,
			"31": 0.14168,
			"32": 0.0308,
			"33": 0.08008,
			"34": 0.02156,
			"35": 0.00924,
			"36": 0.04004,
			"37": 0.00924,
			"38": 0.077,
			"39": 0.11088,
			"40": 0.06776,
			"41": 0.02772,
			"42": 0.04004,
			"43": 0.88396,
			"44": 0.0462,
			"45": 0.04312,
			"46": 0.03696,
			"47": 0.1386,
			"48": 0.06776,
			"49": 0.77,
			"50": 0.14784,
			"51": 0.55132,
			"52": 0.51436,
			"53": 9.48024,
			"54": 2.52868,
			"55": 0.08008,
			"56": 0.00924,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.05544,
			"4": 0.01848,
			"5": 0.01848,
			"6": 0.00924,
			"7": 0.00616,
			"8": 0.0154,
			"9": null,
			"10": 0.01848,
			"11": 0.0616,
			"12": 0.04312,
			"13": 0.01232,
			"14": 0.00616,
			"15": 0.02156,
			"16": 0.01232,
			"17": 0.02464,
			"18": 0.00924,
			"19": 0.00924,
			"20": 0.00616,
			"21": 0.01232,
			"22": 0.02464,
			"23": 0.00616,
			"24": 0.01232,
			"25": 0.04004,
			"26": 0.0308,
			"27": 0.0154,
			"28": 0.02464,
			"29": 0.01848,
			"30": 0.0308,
			"31": 0.02464,
			"32": 0.07392,
			"33": 0.05236,
			"34": 0.0308,
			"35": 0.07084,
			"36": 0.08932,
			"37": 0.0462,
			"38": 0.08932,
			"39": 0.07084,
			"40": 0.05236,
			"41": 0.10164,
			"42": 0.05236,
			"43": 0.462,
			"44": 0.12012,
			"45": 0.16632,
			"46": 0.16632,
			"47": 1.0164,
			"48": 0.81312,
			"49": 5.24524,
			"50": 0.24332,
			"51": 0.0154,
			"52": null,
			"3.5": 0.0154,
			"3.6": 0.02464
		},
		"opera": {
			"9": null,
			"11": 0.00308,
			"12": 0.00308,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.02772,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.01848,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.00616,
			"35": 0.00924,
			"36": 0.0308,
			"37": 0.01848,
			"38": 0.04004,
			"39": 0.01232,
			"40": 0.42812,
			"41": 0.04928,
			"42": 0.00308,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.00924,
			"12.1": 0.0154
		},
		"safari": {
			"0": null,
			"4": 0.00308,
			"5": 0.00616,
			"6": 0.00616,
			"7": 0.00924,
			"8": 0.01232,
			"9": 0.00616,
			"10": 0.0616,
			"3.1": null,
			"3.2": null,
			"5.1": 0.0154,
			"6.1": 0.00616,
			"7.1": null,
			"9.1": 0.04928
		},
		"ios_saf": {
			"8": 0,
			"10": 1.82596962531,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0492077685262,
			"8.1-8.4": 0.0909092672773,
			"9.0-9.2": 0.0433695587011,
			"9.3": 0.661663780183
		},
		"android": {
			"3": 0,
			"4": 0.285382945736,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0356728682171,
			"4.1": 1.02941705426,
			"4.2-4.3": 2.57354263566,
			"4.4": 5.90131162791,
			"4.4.3-4.4.4": 5.95227286822
		},
		"ie": {
			"6": 0.0379516097561,
			"7": 0.00632526829268,
			"8": 0.373190829268,
			"9": 0.148643804878,
			"10": 0.0885537560976,
			"11": 0.632526829268,
			"5.5": null
		},
		"op_mob": {
			"0": 0.574574692042,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0159604081123
		},
		"edge": {
			"12": 0.13244,
			"13": 0.10472,
			"14": 0.16324
		},
		"ie_mob": {
			"10": 0.0300191549296,
			"11": 0.12222084507
		},
		"bb": {
			"7": 0.00346,
			"10": null
		},
		"samsung": {
			"0": 6.58092
		},
		"and_uc": {
			"0": 5.17616
		},
		"op_mini": {
			"0": 7.74114489985
		},
		"and_chr": {
			"0": 30.84308
		},
		"and_ff": {
			"0": 0.0692
		}
	},
	"total": 98.0243720976
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/SY.json
 ** module id = 653
 ** module chunks = 0
 **/